import { useParams } from "react-router-dom";

/*
Currently, the uuid is a token generated from an object containing 3 to 5 values, but with the new architecture, this approach will become obsolete.
*/

export const useUuid = (): string => {
  const params = useParams();

  if (!params.uuid) {
    throw new Error("UUID is required");
  }

  return params.uuid;
};
